import { getMarketingLanguageFromPath, MARKETING_LANGUAGES, MARKETING_LOCALES } from "../../marketing-content/marketingLocales";
import React, { Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { LocaleDirectionProvider } from "../../i18n/LocaleDirectionProvider";
import { isMarketingSiteOrigin, rememberAttributionParamsFromCurrentUrl } from "../landing-page/handoff/appHandoff";
import { MarketingLoadErrorBoundary } from "./MarketingLoadErrorBoundary";
import { MarketingSiteLoadingFallback } from "./MarketingSiteLoadingFallback";

// Separate chunks: a blog reader does not download the landing page's visuals, and the landing page does
// not download the Markdown renderer.
const LandingPage = React.lazy(() => import("../landing-page/LandingPage"));
const MarketingContentPage = React.lazy(() => import("./MarketingContentPage"));

// Every marketing-site URL (see isMarketingSitePath) is rendered here, outside the app's router: none of
// the app's authentication, onboarding or subscription effects apply to these public pages, and none of
// this code is part of the app's startup bundle.
export default function MarketingSiteRouter() {
  const { pathname } = useLocation();
  const language = getMarketingLanguageFromPath(pathname);
  // Ad and referral parameters arrive on whichever marketing page the visitor lands on; they are kept so
  // that a sign-up several pages later still carries them into the app.
  useEffect(() => {
    rememberAttributionParamsFromCurrentUrl();
  }, []);

  return (
    <LocaleDirectionProvider direction={MARKETING_LOCALES[language].direction as "ltr" | "rtl"}>
    <MarketingLoadErrorBoundary>
    <Suspense fallback={<MarketingSiteLoadingFallback />}>
      <Routes>
        {/* On the marketing domain the root is the landing page; on the app's domain "/" is the app's home. */}
        {isMarketingSiteOrigin() && MARKETING_LANGUAGES.map(language => <Route key={language} path={MARKETING_LOCALES[language].home} element={<LandingPage isProductionLanding htmlLang={language} />} />)}
        {/* Landing page design preview with the version switcher, on every origin. */}
        <Route path="/testing" element={<LandingPage />} />
        {/* Blog, use-cases, pricing, … The page looks its own content up from the URL and renders the
            marketing "page not found" when nothing matches. */}
        <Route path="*" element={<MarketingContentPage />} />
      </Routes>
    </Suspense>
    </MarketingLoadErrorBoundary>
    </LocaleDirectionProvider>
  );
}
